import React, { Component } from 'react';
import {
  Modal,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';

import { updtClientVatNumber } from '../../../../helpers/api';

class VatNumberModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vatNumber: null,
      error: null,
      pending: false,
    };
  }

  handleVatNumber = (event) => {
    this.setState({ vatNumber: event.target.value });
  };

  updtVatNumber = () => {
    if (!this.state.vatNumber)
      this.setState({ error: 'Invalid vatNumber!', pending: false });
    else {
      this.setState({ pending: true, error: null });
      this._asyncRequest = updtClientVatNumber(
        this.props.publicKeyHash,
        this.state.vatNumber,
      )
        .then((res) => {
          if (res.status === 'SUCCESS') {
            this.props.loadClient();
            this.props.toggleVatNumberModal();
          } else {
            this.setState({ error: res.error, pending: false });
          }
        })
        .catch((error) => {
          this.setState({ error: error.toString(), pending: false });
        });
    }
  };

  render() {
    return (
      <Modal
        size="md"
        isOpen={this.props.vatNumberModal}
        centered={true}
        backdrop="static"
        wrapClassName="modal-balance"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Update VAT Number
          </h5>
        </div>
        <div className="modal-body">
          {this.state.error && (
            <p className="text-danger">{this.state.error}</p>
          )}
          <FormGroup>
            <Label>VatNumber</Label>

            <Row>
              <Col sm="12">
                <InputGroup className="mb-2">
                  <InputGroupAddon addonType="prepend">
                    <span className="input-group-text">VatNumber</span>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    className="form-control"
                    onChange={this.handleVatNumber}
                    autoComplete="off"
                  />
                </InputGroup>
              </Col>
            </Row>
          </FormGroup>
          {this.state.pending ? (
            <p>Processing...</p>
          ) : (
            <Row className="mt-3">
              <Col sm="4">
                <button
                  className="btn btn-primary btn-block waves-effect waves-light"
                  type="submit"
                  onClick={() => this.props.toggleVatNumberModal()}
                >
                  Close
                </button>
              </Col>
              <Col sm="6">
                <button
                  className="btn btn-warning btn-block waves-effect waves-light"
                  type="submit"
                  onClick={() => {
                    this.updtVatNumber();
                  }}
                >
                  Update
                </button>
              </Col>
            </Row>
          )}
        </div>
      </Modal>
    );
  }
}

export default VatNumberModal;
